module.exports = __webpack_public_path__ + "static/img/surface8.6906663.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/surface8.png
// module id = uuGk
// module chunks = 2